/**
 * Functionality regarding everything around the navigation of the website
 * @path: components/navigation
 */
window.navigation = function() {
    var self            = this;
    var $body           = $('body'); 
    var $window         = $(window);
    var $nav_icon       = $('.js-nav-icon');
    var nav_anchor      = document.querySelectorAll('.js-nav-anchor');
    var $body           = $('body');

    self.init = function() {
        self.setListenerToggleMobileMainNav();
        self.setListenerCloseMobileMainNavOnResize();
        self.setListenerNavAnchor();
    };

    /**
     * Toggle class on body so mobile menu can be animated
     *
     * @author Rianne Oosthoek <rianne@click.nl>
     * @return void
     */
    self.setListenerToggleMobileMainNav = function() {
        $nav_icon.click(function() {
            $body.toggleClass('is-overlay-open u-disable-scroll' );
        });
    };

    /**
     * Close navigations when reaching desktop breakpoint
     *
     * @author Rianne Oosthoek <rianne@click.nl>
     * @return void
     */
    self.setListenerCloseMobileMainNavOnResize = function() {
        var window_width = getWindowWidth();

        $window.on('orientationchange resize', function() {
            window_width = getWindowWidth();

            // Close side menu when entering large screensize
            if( window_width > getBreakpointSize('xlarge') && $body.hasClass('is-overlay-open') ) {
                $body.removeClass('is-overlay-open u-disable-scroll');
            }
        });
    };

    self.setListenerNavAnchor = function(){
        nav_anchor.forEach((element) => {
            element.addEventListener('click', () => {
                element.firstElementChild.classList.remove('is-disabled');
            });
        });
    };
};


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/navigation.js